import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if(environment.prefix === 'se' || environment.prefix === 'prod') {
  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.innerHTML = '(function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\n' +
    '          (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n' +
    '          m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n' +
    '      })(window,document,\'script\',\'https://www.google-analytics.com/analytics.js\',\'ga\');\n' +
    '\n' +
    '      ga(\'create\', \'' + environment.googleAnalyticsUA + '\', \'auto\');\n' +
    '      ga(\'send\', \'pageview\');';

  const head = document.getElementsByTagName('head')[0];
  head.appendChild(s);
  if (environment.production) {
    enableProdMode();
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// ./src/main.ts